import React from 'react';
import MakeAdmin from './MakeAdmin';

const Users = () => {
    return (
        <div>
            <MakeAdmin></MakeAdmin>
        </div>
    );
};

export default Users;